// Add your custom JS here.
(function ($) {

    $('.gform-button').addClass('primary-btn');
    $('.gform_button').addClass('primary-btn-alt');
    $('.single_add_to_cart_button').addClass('primary-btn-alt');
    $('.product-box .entry-summary .btn-outline-primary').addClass('primary-btn-alt');
    $('.product_type_simple').addClass('primary-btn');
    $('.wc-proceed-to-checkout a').addClass('primary-btn');
    $('.swp-result-item--button').addClass('primary-btn');
    $('.shop_table .actions button').addClass('white-btn');
    $('.wpmm-row').addClass('container');
    $('.woo-breadcrumbs').addClass('container');

    $('.wapf').prependTo(".variations_form");
    $('.iconic-wlv-variations__row--pa_bowl-size td.label').append('<span>Diameter</span>');

    $('.search-results #content').removeClass('container-fluid');
    $('.search-results #content').addClass('container');
    $('.swp-rp-main').addClass('container');


    $('.specifications-tab-link').click(function() {
      $('.specifications-tab').addClass('active');
    });

    $(document).ready(function() {

      function equalizeHeightsp() {
        $('.quick-links').each(function () {
          let maxHeightp = 0;
          const $contents = $(this).find('.quick-link-content');
      
          // Reset heights first to avoid compounding
          $contents.css('height', 'auto');
      
          // Find the tallest
          $contents.each(function () {
            const currentHeightp = $(this).height();
            if (currentHeightp > maxHeightp) {
              maxHeightp = currentHeightp;
            }
          });
      
          // Apply max height to all in this section
          $contents.height(maxHeightp);
        });
      }
      
      // Run after everything is fully loaded
      equalizeHeightsp();
      
      // Reapply on resize
      $(window).on('resize', function () {
        clearTimeout(window._resizeTimer);
        window._resizeTimer = setTimeout(equalizeHeightsp, 100);
      });
      


        $('.iconic-wlv-terms__term--partial-match').remove();

        var targetClass1 = 'iconic-wlv-terms__term--partial-match';

        $('.iconic-wlv-variations__value ul.iconic-was-swatches').each(function(index) {
          var $ul = $(this);
          var $listItems = $ul.children('li');

          var allHaveClass = $listItems.length > 0 && $listItems.toArray().every(function(li) {
            return $(li).hasClass(targetClass1);
          });

          if (allHaveClass) {
            $ul.parent().parent().hide();
          }
        });

        var targetClass2 = 'product_cat-alabaster-lighting';

        // Select all child divs you want to potentially hide
        $('tr.iconic-wlv-variations__row--pa_family').each(function() {
          var $child = $(this);

          // Check if any ancestor (including immediate parent) has the target class
          var hasMatchingAncestor = $child.closest('.' + targetClass2).length > 0;

          if (!hasMatchingAncestor) {
            $child.remove();
          }
        });

        $('.iconic-wlv-terms').each(function() {
          var $select = $(this);
      
          // Save the selected value before modifying the DOM
          var selectedVal = $select.val();
      
          // Move options out of optgroups
          $select.find('optgroup').each(function() {
            var $optgroup = $(this);
            $optgroup.children('option').appendTo($select);
            $optgroup.remove();
          });
      
          // Re-apply the originally selected value
          $select.val(selectedVal);
        });
        
        $('select.iconic-wlv-terms').each(function () {
          const optionCount = $(this).find('option').length;
        
          // Adjust this logic if the first option is a placeholder (like "Please select...")
          if (optionCount <= 1) {
            $(this).closest('tr').remove();
          }
        });

        $('.iconic-wlv-variations tbody').each(function () {
          if ($(this).children().length === 0) {
            $(this).parent('table').remove();
          }
        });

        // Find the label associated with attributes
        var $finish_label = $('label[for="pa_finish"]');
        var $tint_label = $('label[for="pa_tint"]');
        var $glass_label = $('label[for="pa_art-glass"]');
        var $shade_label = $('label[for="pa_shade"]');

        // Create your custom link
        var $finish_link = $('<a href="/metal-finishes/" class="guide-link">See Finish Options</a>');
        var $tint_link = $('<a href="/alabaster-options/" class="guide-link">See Tint Options</a>');
        var $glass_link = $('<a href="/glass-panels/" class="guide-link">See Art Glass Options</a>');
        var $shade_link = $('<a href="/shades/" class="guide-link">See Shade Options</a>');

        // Insert the link after the label
        $finish_label.after($finish_link);
        $tint_label.after($tint_link);
        $glass_label.after($glass_link);
        $shade_label.after($shade_link);

        
        function toggleMagnifier() {
          var $trigger = $('.woocommerce-product-gallery__trigger');
          var $activeSlide = $('.woocommerce-product-gallery__wrapper .flex-active-slide');
      
          if ($activeSlide.find('.Sirv').length > 0) {
            $trigger.hide();
          } else {
            $trigger.show();
          }
        }
      
        // Initial run
        toggleMagnifier();
      
        // On flexslider init and after each slide change
        $('.woocommerce-product-gallery').on('init', toggleMagnifier);
        $('.woocommerce-product-gallery').on('after.wc-flexslider', toggleMagnifier);
      
        // On variation change
        $('form.variations_form').on('found_variation reset_data', function() {
          setTimeout(toggleMagnifier, 100);
        });
      
        // Delegated event: thumbnail click
        $(document).on('click', '.flex-control-thumbs img', function() {
          setTimeout(toggleMagnifier, 200);
        });


        // Add error alerts to attributes that are not selected on product pages
        var $form = $('form.variations_form');

        // Watch for reset (incomplete variation selection)
        $form.on('reset_data', function() {
            $('.variation-notice').remove();
            $form.find('.single_add_to_cart_button').after('<p class="variation-notice" style="color:red;">Please select all required options.</p>');
        });

        // Clear message once a valid variation is selected
        $form.on('show_variation', function() {
            $('.variation-notice').remove();
        });

        

        // Infinite scroll searchWP function
        if (typeof swpInfinite !== 'undefined') {
          var page      = 2;
          var loading   = false;
          var exhausted = false;

          var $container = $('.swp-search-results');

          // Hide existing pagination
          $('.swp-pagination, .searchwp-pagination, .nav-links').hide();

          // Add a loading spinner below results
          $container.after('<div class="swp-infinite-loader" style="text-align:center;padding:20px;display:none;">Loading...</div>');
          var $loader = $('.swp-infinite-loader');

          $(window).on('scroll', function () {
              if (loading || exhausted) return;

              var scrollBottom = $(window).scrollTop() + $(window).height();
              var pageBottom   = $(document).height() - 300;

              if (scrollBottom >= pageBottom) {
                  loading = true;
                  $loader.show();

                  // Build the next page URL exactly matching SearchWP's format
                  var nextUrl = swpInfinite.baseUrl 
                      + '?swppg=' + page 
                      + '&swp_form%5Bform_id%5D=' + swpInfinite.formId 
                      + '&swps=' + encodeURIComponent(swpInfinite.query);

                  $.get(nextUrl, function (response) {
                      // Parse the returned page and extract result items
                      var $html     = $(response);
                      var $newItems = $html.find('.swp-result-item');

                      if ($newItems.length > 0) {
                          $container.append($newItems);
                          $newItems.find('.swp-result-item--button').addClass('primary-btn'); // ✅ apply to new items
                          page++;
                          loading = false;
                          $loader.hide();
                      } else {
                          // No more results
                          exhausted = true;
                          $loader.hide();
                      }
                  }).fail(function () {
                      loading = false;
                      $loader.hide();
                  });
              }
          });
        }

        
  });

})(jQuery);